import { render, staticRenderFns } from "./ModalCodAgreement.vue?vue&type=template&id=2c67e949&scoped=true&"
import script from "./ModalCodAgreement.vue?vue&type=script&lang=js&"
export * from "./ModalCodAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ModalCodAgreement.vue?vue&type=style&index=0&id=2c67e949&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c67e949",
  null
  
)

export default component.exports